var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightPurple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#183690",
  d: "m20.648 12.4-6.75 6.75a.563.563 0 0 1-.796-.796l5.79-5.79H3.75a.563.563 0 0 1 0-1.125h15.142l-5.79-5.79a.562.562 0 0 1 .796-.795l6.75 6.75a.563.563 0 0 1 0 .795"
})));
export default SvgArrowRightPurple;